<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Přidat nový typ události</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Typ události" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Zpřístupnění"
                    class="mx-2"
                    :items="selects"
                    :rules="rulesRequired"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Workshop"
                    class="mx-2"
                    :items="selects"
                    :rules="rulesRequired"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Certifikace"
                    class="mx-2"
                    :items="selects"
                    :rules="rulesRequired"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create()" :loading="sending">Přidat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs6 sm9>
                <h3>Typy událostí</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs6 sm3>
                <v-btn color="blue darken-3" class="ma-0 mb-3 right" outline @click="createClick()">
                  <v-icon class="mr-2">add</v-icon>
                  Přidat
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.typ_udalosti }}</td>
                  <td>{{ props.item.zpoplatneni }}</td>
                  <td>{{ props.item.workshop }}</td>
                  <td>{{ props.item.certifikace }}</td>
                  <td class="text-center">
                    <v-btn flat icon color="red" class="elevation-0">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      dialogCreate: false,
      headers: [
        { text: 'Typ události', value: 'typ_udalosti' },
        { text: 'Zpoplatnění', value: 'zpoplatneni' },
        { text: 'Workshop', value: 'workshop' },
        { text: 'Certifikace', value: 'certifikace' },
        { text: 'Smazat', value: null, sortable: false, align: 'center' }
      ],
      items: [
        {
          typ_udalosti: 'Porada',
          zpoplatneni: 'Ne',
          workshop: 'Ne',
          certifikace: 'Ano'
        },
        {
          typ_udalosti: 'Školení',
          zpoplatneni: 'Ano',
          workshop: 'Ne',
          certifikace: 'Ne'
        }
      ],
      selects: [
        'Ano',
        'Ne'
      ]
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  methods: {
    createClick () {
      //this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Udalosti/TypyUdalosti.vue